"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regularSelect = _interopRequireDefault(require("./regularSelect"));
var _createSelect = _interopRequireDefault(require("./createSelect"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function WpfSelect(props) {
  if (window.wpf_admin.crm_supports.includes('add_tags') || window.wpf_admin.crm_supports.includes('add_tags_api')) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(_createSelect["default"], props));
  }
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(_regularSelect["default"], props));
}
var _default = exports["default"] = WpfSelect;